import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { MdSend, MdAttachFile, MdClose, MdDelete } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";

function Compose_Email({
  open4,
  setOpen4,
  slected_num,
  email,
  handleOpen,
  tracking_num,
  isDarkMode,
  recipientEmail,
  isFromNotification = false,
  templateData = {}
}) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toCC, setCC] = useState("");

  const theme = {
    bg: isDarkMode ? "#1a1a1a" : "#ffffff",
    text: isDarkMode ? "#e0e0e0" : "#333333",
    inputBg: isDarkMode ? "#2d2d2d" : "#f5f5f5",
    border: isDarkMode ? "#333333" : "#e0e0e0",
    accent: isDarkMode ? "#4dabf5" : "#007bff",
    cardBg: isDarkMode ? "#252525" : "#ffffff",
    secondaryText: isDarkMode ? "#aaaaaa" : "#666666",
    fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif"

  };

  const templateBtnStyle = (t) => ({
    padding: "6px 12px",
    borderRadius: "20px",
    border: `1px solid ${t.border}`,
    backgroundColor: t.inputBg,
    color: t.text,
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "500",
    transition: "all 0.2s"
  });

  useEffect(() => {
    // Set default sender if provided, or fallback
    if (email) {
      setFrom(email);
    } else {
      setFrom("gopalayush04@gmail.com");
    }

    if (recipientEmail) {
      setTo(recipientEmail);
      // Reset subject and body when recipient changes (new chat context)
      setSubject("");
      setBody("");
      setAttachments([]);
    } else {
      setTo("");
      setSubject("");
      setBody("");
      setAttachments([]);
    }
  }, [email, recipientEmail, slected_num]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setAttachments((prev) => [...prev, ...files]);
  };

  const handleTemplateSelect = (type) => {
    if (!templateData) return;

    const name = templateData.fullname || templateData.customer_name || templateData.name || "Customer";
    const orderId = templateData.order_id || templateData.id || templateData.order_number || "Order"; // covering potential keys

    if (type === "delivery") {
      setSubject(`Order #${orderId} Out for Delivery`);
      setBody(`Hi ${name},\n\nYour order #${orderId} is out for delivery today. Please ensure someone is available to receive it.\n\nThanks,\nCasual Footwears`);
    } else if (type === "dispatched") {
      setSubject(`Order #${orderId} Dispatched`);
      setBody(`Hi ${name},\n\nYour order #${orderId} has been dispatched from our warehouse.\n\nThanks,\nCasual Footwears`);
    } else if (type === "confirmed") {
      setSubject(`Order #${orderId} Confirmed`);
      setBody(`Hi ${name},\n\nThank you for your order #${orderId}. We have received it and will process it shortly.\n\nThanks,\nCasual Footwears`);
    }
  };

  const removeAttachment = (index) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
  }

  const handleSend = async () => {
    const baseUrl = 'https://casualfootwears.com/api/send_mail/';
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("mail_sub", subject);
      formData.append("selected_mail", from);
      formData.append("mail_body", body);
      formData.append("mail_to", to);
      formData.append("mail_cc", toCC);

      // Append attachments
      attachments.forEach((file, index) => {
        formData.append(`attachments[${index}]`, file);
      });

      const res = await axios.post(baseUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Update usage stats if needed
      if (slected_num) {
        await axios.post(
          process.env.REACT_APP_LAST_USED_MAIL_API,
          { [slected_num]: from }
        );
      }

      setLoading(false);
      toast.success("Email sent successfully");
      setOpen4(false);
      setTo("");
      setSubject("");
      setBody("");
      setAttachments([]);
      setCC("");


    } catch (error) {
      toast.error("Failed to send email");
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open4}
      onClose={() => setOpen4(false)}
      center
      classNames={{ modal: "customModal" }}
      styles={{
        modal: {
          maxWidth: "800px",
          width: "95%",
          padding: "0",
          borderRadius: "16px",
          backgroundColor: theme.cardBg,
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          fontFamily: theme.fontFamily
        },
        overlay: {
          background: "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(4px)"
        }
      }}
      showCloseIcon={false}
    >
      <div style={{ padding: "24px", color: theme.text }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>Compose Email</h2>
          <button
            onClick={() => setOpen4(false)}
            style={{
              background: "none",
              border: "none",
              color: theme.text,
              cursor: "pointer",
              padding: "5px",
              display: "flex"
            }}
          >
            <MdClose size={24} />
          </button>
        </div>

        {/* Templates Section (Only from Notification) */}
        {isFromNotification && (
          <div style={{ marginBottom: "20px", display: "flex", gap: "10px", alignItems: "center" }}>
            <span style={{ fontSize: "13px", fontWeight: "600", color: theme.secondaryText }}>Quick Templates:</span>
            <button onClick={() => handleTemplateSelect("delivery")} style={templateBtnStyle(theme)}>🚚 Delivery</button>
            <button onClick={() => handleTemplateSelect("dispatched")} style={templateBtnStyle(theme)}>📦 Dispatched</button>
            <button onClick={() => handleTemplateSelect("confirmed")} style={templateBtnStyle(theme)}>✅ Confirmed</button>
            <button onClick={() => { setSubject(""); setBody(""); }} style={{ ...templateBtnStyle(theme), backgroundColor: theme.inputBg, border: "1px dashed " + theme.secondaryText }}>❌ Clear</button>
          </div>
        )}

        {/* Form Fields */}
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {/* From Field (Read Only or Select) */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ width: "60px", color: theme.secondaryText, fontSize: "14px", fontWeight: "500" }}>From:</label>
            <input
              type="text"
              value={from}
              readOnly
              style={{
                flex: 1,
                padding: "10px 12px",
                borderRadius: "8px",
                border: `1px solid ${theme.border}`,
                backgroundColor: theme.inputBg,
                color: theme.text,
                fontSize: "14px",
                outline: "none"
              }}
            />
          </div>

          {/* To Field */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ width: "60px", color: theme.secondaryText, fontSize: "14px", fontWeight: "500" }}>To:</label>
            <input
              type="text"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              placeholder="Recipient email"
              style={{
                flex: 1,
                padding: "10px 12px",
                borderRadius: "8px",
                border: `1px solid ${theme.border}`,
                backgroundColor: "transparent",
                color: theme.text,
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s"
              }}
              onFocus={(e) => e.target.style.borderColor = theme.accent}
              onBlur={(e) => e.target.style.borderColor = theme.border}
            />
          </div>

          {/* CC Field */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ width: "60px", color: theme.secondaryText, fontSize: "14px", fontWeight: "500" }}>CC:</label>
            <input
              type="text"
              value={toCC}
              onChange={(e) => setCC(e.target.value)}
              placeholder="CC emails"
              style={{
                flex: 1,
                padding: "10px 12px",
                borderRadius: "8px",
                border: `1px solid ${theme.border}`,
                backgroundColor: "transparent",
                color: theme.text,
                fontSize: "14px",
                outline: "none"
              }}
              onFocus={(e) => e.target.style.borderColor = theme.accent}
              onBlur={(e) => e.target.style.borderColor = theme.border}
            />
          </div>

          {/* Subject Field */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ width: "60px", color: theme.secondaryText, fontSize: "14px", fontWeight: "500" }}>Subject:</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Email subject"
              style={{
                flex: 1,
                padding: "10px 12px",
                borderRadius: "8px",
                border: `1px solid ${theme.border}`,
                backgroundColor: "transparent",
                color: theme.text,
                fontSize: "14px",
                fontWeight: "500",
                outline: "none"
              }}
              onFocus={(e) => e.target.style.borderColor = theme.accent}
              onBlur={(e) => e.target.style.borderColor = theme.border}
            />
          </div>

          {/* Body Field */}
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Write your message here..."
            style={{
              width: "100%",
              minHeight: "300px",
              padding: "15px",
              borderRadius: "8px",
              border: `1px solid ${theme.border}`,
              backgroundColor: "transparent",
              color: theme.text,
              fontSize: "15px",
              fontFamily: theme.fontFamily,
              resize: "vertical",
              outline: "none",
              lineHeight: "1.5"
            }}
            onFocus={(e) => e.target.style.borderColor = theme.accent}
            onBlur={(e) => e.target.style.borderColor = theme.border}
          />

          {/* Attachments Section */}
          {attachments.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: "10px", backgroundColor: theme.inputBg, borderRadius: "8px" }}>
              {attachments.map((file, index) => (
                <div key={index} style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: theme.cardBg,
                  padding: "6px 10px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.border}`,
                  fontSize: "13px"
                }}>
                  <span style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                  <MdClose
                    size={16}
                    style={{ cursor: "pointer", color: theme.secondaryText }}
                    onClick={() => removeAttachment(index)}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Footer Actions */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
            <div>
              <input
                type="file"
                id="file-input"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-input">
                <span style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                  color: theme.text,
                  padding: "8px 12px",
                  borderRadius: "8px",
                  backgroundColor: theme.hover
                }}>
                  <MdAttachFile size={20} /> <span style={{ fontSize: "14px", fontWeight: "500" }}>Attach files</span>
                </span>
              </label>
            </div>

            <button
              onClick={handleSend}
              disabled={loading}
              style={{
                padding: "10px 24px",
                borderRadius: "30px",
                border: "none",
                backgroundColor: theme.accent,
                color: "#fff",
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: "600",
                fontSize: "15px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                transition: "transform 0.2s",
                opacity: loading ? 0.7 : 1
              }}
              onMouseEnter={(e) => !loading && (e.currentTarget.style.transform = "translateY(-2px)")}
              onMouseLeave={(e) => !loading && (e.currentTarget.style.transform = "translateY(0)")}
            >
              {loading ? <CircularProgress size={20} style={{ color: "#fff" }} /> : <><MdSend size={18} /> Send Email</>}
            </button>
          </div>
        </div>

      </div>
    </Modal>
  );
}

export default Compose_Email;
